import buildImageSrc from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { MediaType } from '@repo/ui/src/types/image';
import { LinkProps } from '@repo/ui/src/types/link';
import Image from '@repo/ui/src/components/Image/New';

interface Props {
  slide: {
    image?: MediaType;
    link?: LinkProps;
  };
  index: number;
}

const LogoSlide = ({ slide: { image, link } }: Props) => {
  const Element = link ? Anchor : 'div';
  return (
    <Element
      className="flex flex-col items-center justify-center h-full focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2"
      {...(link ?? {})}
      tabIndex={0}
    >
      <Image src={buildImageSrc(image)} width={150} height={150} alt={image?.name || 'logo'} />
    </Element>
  );
};

export default LogoSlide;
